/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_No_Display_NameInputs */

const en_common_no_display_name = /** @type {(inputs: Common_No_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No display name provided`)
};

const es_common_no_display_name = /** @type {(inputs: Common_No_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay nombre para mostrar`)
};

/**
* | output |
* | --- |
* | "No display name provided" |
*
* @param {Common_No_Display_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_no_display_name = /** @type {((inputs?: Common_No_Display_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_No_Display_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_no_display_name(inputs)
	return en_common_no_display_name(inputs)
});